import { create } from 'zustand';

import { mockAvatars } from '../mock/mockAvatars';
import { ChangeAvatarStep } from './types';

interface UserAvatarState {
  userAvatar?: string;
  step: ChangeAvatarStep;
  testAvatar?: string;
}
interface UserAvatarActions {
  setUserAvatar: (avatar: string | undefined) => void;
  setStep: (step: ChangeAvatarStep) => void;
  setTestAvatar: (testAvatar: string | undefined) => void;
  reset: VoidFunction;
}
export const useAvatarStore = create<UserAvatarState & UserAvatarActions>(
  (set) => ({
    userAvatar: mockAvatars[1].imageSrc,
    testAvatar: mockAvatars[1].imageSrc,
    step: 'select',
    setUserAvatar: (userAvatar: string | undefined) => {
      set({ userAvatar });
    },
    setTestAvatar: (testAvatar: string | undefined) => {
      set({ testAvatar });
    },
    setStep: (step: ChangeAvatarStep) => {
      set({ step });
    },
    reset: () => {
      set((state) => ({ testAvatar: state.userAvatar, step: 'select' }));
    },
  }),
);
